export class SubscriptionStatusApi {
    /**
     * @param {number} userId
     * @param {number} starId
     * @param {string} correlationId
     * @param {string} grantedUntil
     * @param {boolean} isActive
     * @returns {Response}
     */
    async fetch(userId, starId, correlationId, grantedUntil, isActive) {
        return await window.fetch("/api/stars/subscriptionstatus", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({
                userId,
                starId,
                correlationId,
                grantedUntil,
                isActive,
            }),
        })
    }
}
